import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Trash2 } from "lucide-react";

export function ConfirmDelete({ onConfirm, testid, small }) {
  const [ask, setAsk] = useState(false);
  return ask
    ? <Button size={small ? "sm" : "default"} variant="destructive" data-testid={`${testid}-confirm`} onClick={async (e) => { e.stopPropagation(); await onConfirm(); setAsk(false); }}>Conferma eliminazione</Button>
    : <Button size={small ? "sm" : "default"} variant="outline" className="text-destructive border-destructive/40" data-testid={testid} onClick={(e) => { e.stopPropagation(); setAsk(true); }}><Trash2 size={15} /></Button>;
}

function Field({ f, value, onChange }) {
  const id = `fd-${f.k}`;
  if (f.type === "select") return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger data-testid={id}><SelectValue placeholder="Scegli" /></SelectTrigger>
      <SelectContent onCloseAutoFocus={(e) => e.preventDefault()}>{f.options.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
    </Select>
  );
  if (f.type === "textarea") return <Textarea data-testid={id} rows={2} value={value ?? ""} onChange={(e) => onChange(e.target.value)} placeholder={f.ph} />;
  return <Input data-testid={id} type={f.type || "text"} step={f.type === "number" ? "any" : undefined} inputMode={f.type === "number" ? "decimal" : undefined}
    value={value ?? ""} onChange={(e) => onChange(e.target.value)} placeholder={f.ph} />;
}

export default function FieldsDialog({ open, title, fields, initial, onClose, onSave, onDelete, testid }) {
  const [form, setForm] = useState({});
  useEffect(() => { if (open) setForm({ ...(initial || {}) }); }, [open, initial]);
  useEffect(() => {
    if (!open) { const t = setTimeout(() => { if (document.body.style.pointerEvents === "none") document.body.style.pointerEvents = ""; }, 200); return () => clearTimeout(t); }
  }, [open]);
  const visible = fields.filter((f) => !f.show || f.show(form));
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid={testid}>
        <DialogHeader><DialogTitle className="font-head">{title}</DialogTitle><DialogDescription className="sr-only">Compila e salva</DialogDescription></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {visible.map((f) => (
            <div key={f.k} className={f.half ? "col-span-1" : "col-span-2"}>
              <Label className="text-xs">{f.label}</Label>
              <Field f={f} value={form[f.k]} onChange={(v) => setForm((x) => ({ ...x, [f.k]: v }))} />
              {f.hint && <p className="text-[11px] text-muted-foreground mt-0.5">{f.hint}</p>}
            </div>
          ))}
        </div>
        <DialogFooter className="flex-row gap-2 sm:justify-between">
          {onDelete ? <ConfirmDelete testid={`${testid}-delete`} onConfirm={onDelete} /> : <span />}
          <Button className="bg-brand hover:bg-[#A8472F] text-white" data-testid={`${testid}-save`} onClick={() => onSave(form)}>Salva</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
